import { Scissors, Layers } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

const ICONS = [Scissors, Layers];

export default function TickerStrip({ inverted = false }) {
    const { t } = useLanguage();
    const items = t("strip.items");

    return (
        <div
            className={`border-y ${inverted ? "bg-black text-white border-black" : "bg-white text-black border-zinc-200"}`}
            data-testid="ticker-strip"
        >
            <div className="grid grid-cols-1 md:grid-cols-2">
                {items.map((item, i) => {
                    const Icon = ICONS[i];
                    return (
                        <div
                            key={i}
                            className={`flex items-center justify-center gap-3 py-6 px-4 ${
                                i > 0 ? `border-t md:border-t-0 md:border-l ${inverted ? "border-zinc-800" : "border-zinc-200"}` : ""
                            }`}
                        >
                            <Icon size={18} strokeWidth={1.5} aria-hidden="true" />
                            <span className="font-display text-sm md:text-base font-bold tracking-[0.2em] uppercase">
                                {item}
                            </span>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
